// extracted by mini-css-extract-plugin
export default {"link-btn":"SelectTemplate_link-btn__Kn2Rq"};